// extracted by mini-css-extract-plugin
export default {"container":"blood-board_container__RaYV5","hooks":"blood-board_hooks__HxB38","hook-anchors":"blood-board_hook-anchors__Q8tcX"};